import { setConsentCookie } from './ConsentCookie.js'

document.addEventListener('DOMContentLoaded', () => {
  if ('CookieBar' in window) {
    setConsentCookie()
  }
})
